import { AppKey } from '../app/AppKey';
import { updateKeyValue } from '../store/app/action-creators';
import { setCookiesAccepted } from '../store/auth/action-creators';
import { GdprEventSetup } from './GdprEvent';

const onGdprEvent = (event, store) => {
  if (event.detail.country) {
    store.dispatch(updateKeyValue(AppKey.Country, event.detail.country));
  }

  if (event.detail.consent && event.detail.consent.allowed) {
    store.dispatch(setCookiesAccepted());
  }
};

export const setupGdpr = store => {
  GdprEventSetup();
  document.addEventListener('gdpr', event => {
    onGdprEvent(event, store);
  });
};